import { array, bool, string } from "prop-types";
import React, { useEffect, useState } from "react";
import CustomizedMediumStoryCard from "../../../molecules/CustomizedMediumStoryCard";
import "./organism2.m.css";

const Organism2 = ({ storyList, isPublished = true, updatedFont = false, publisherLang, isCommentedStory = false }) => {
  const [showCardDetails, setShowCardDetails] = useState(false);

  useEffect(() => {
    global.deviceWidth > 1263 && setShowCardDetails(!showCardDetails);
  }, []);

  return (
    <div styleName="base">
      {storyList.map(({ story }, index) => (
        <CustomizedMediumStoryCard
          story={story}
          key={index}
          storyHeadlineType={24}
          showCardDetails={showCardDetails}
          isPublished={isPublished}
          widths={global.deviceWidth < 1264 ? [150] : [300]}
          isExcerpt={true}
          updatedFont={updatedFont}
          publisherLang={publisherLang}
          isCommentedStory={isCommentedStory}
        />
      ))}
    </div>
  );
};

Organism2.propTypes = {
  storyList: array.isRequired,
  isPublished: bool,
  updatedFont: bool,
  publisherLang: string,
  isCommentedStory: bool,
};

export default Organism2;
